// The single Supabase client for the whole app. Built from the PUBLIC publishable key
// (safe in client code — access is bounded by row-level security), with env overrides so a
// build can point at a staging project without a code change.
//
// OFFLINE-FIRST + SINGLE SIGN-IN: the session persists in chunked cookies on
// Domain=.seabearing.com (shared with seabearing.com and data.seabearing.com — sign in once,
// signed in everywhere) WITH a localStorage mirror on this origin, because Safari caps JS-set
// cookies at 7 days and a boat offline for a month must still restore its session. That cached
// session — plus the tier we cache alongside it (see ./store) — is what lets premium tiles
// unlock offline. The whole app must keep working signed-OUT; this module only ever ADDS
// capability, it never gates the chart.

import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { createSharedStorage } from './sharedStorage';

export const SUPABASE_URL =
  (import.meta.env?.VITE_SUPABASE_URL as string | undefined) ?? 'https://ausolarpeuemimpmbiho.supabase.co';
const SUPABASE_ANON_KEY =
  (import.meta.env?.VITE_SUPABASE_ANON_KEY as string | undefined) ??
  'sb_publishable_CdUNKIy2P6cdyxFdbid4SQ_NcGzmvSg';

// Session storage key — MUST match the landing site (landing/auth.js) and the data explorer so
// the cookie session is one and the same everywhere. 'seabearing:auth' is the pre-SSO
// localStorage key; sessions stored under it are migrated on first read.
const AUTH_STORAGE_KEY = 'seabearing-auth';

export const supabase: SupabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    // Stay signed in across reloads / restarts with no network round-trip.
    persistSession: true,
    autoRefreshToken: true,
    storage: createSharedStorage({ mirror: true, legacyKeys: ['seabearing:auth'] }),
    storageKey: AUTH_STORAGE_KEY,
    // Pick up the session from the URL fragment after a magic-link / OAuth redirect.
    detectSessionInUrl: true,
    // PKCE is the recommended browser flow (works for magic-link + OAuth without a secret).
    flowType: 'pkce',
  },
});
